export enum SortOrder {
  None = 0,
  AZ = 1,
  ZA = 2
}
